import qs, { IStringifyOptions } from 'qs';

const filterOutEmptyParams = (params: any): any =>
  Object.keys(params)
    .filter((key) => params[key])
    .reduce((res, key) => Object.assign(res, { [key]: params[key] }), {});

interface IRecursiveObjectType {
  [key: string]:
    | string
    | string[]
    | number
    | number[]
    | IRecursiveObjectType
    | IRecursiveObjectType[];
}

export interface IAttachPropertiesToUrlProps {
  [key: string]: IRecursiveObjectType | string;
}

/**
 * @deprecated please use IAttachPropertiesToUrlProps
 */
export interface IAttachParamsToUrlProps {
  params?: any;
  filters?: IRecursiveObjectType;
  order?: IRecursiveObjectType;
  search?: string;
  url: string;
}

export const stringifyOption: IStringifyOptions = {
  encodeValuesOnly: true,
  arrayFormat: 'brackets',
  skipNulls: true,
};

/**
 * @deprecated please use attachPropertiesToUrl
 */
const attachParamsToUrl = ({
  params,
  filters,
  search,
  url,
  order,
}: IAttachParamsToUrlProps): string => {
  const mergedParams = [
    params && qs.stringify(filterOutEmptyParams(params), stringifyOption),
    filters && qs.stringify({ filters }, stringifyOption),
    order && qs.stringify({ order }, stringifyOption),
    search && qs.stringify({ search }, stringifyOption),
  ]
    .filter((item) => item)
    .join('&');

  return `${url}?${mergedParams}`;
};

/**
 * Convert route properties object to query string.
 *
 * The resulting query string doesn't contain the starting `?`.
 *
 * @param params route properties object
 * @returns query string with parameters
 */
export const stringifyProperties = (params: IAttachPropertiesToUrlProps): string =>
  Object.keys(params)
    .filter((key) => params[key])
    .map((key) =>
      qs.stringify(
        key === 'params' ? filterOutEmptyParams(params[key]) : { [key]: params[key] },
        stringifyOption
      )
    )
    .filter((item) => item)
    .join('&');

/**
 * Attaches params to url.
 *
 * @param url url to attach properties to
 * @param params route parameters object
 * @returns full url with query string built from route parameters
 */
export const attachPropertiesToUrl = (url: string, params: IAttachPropertiesToUrlProps): string => {
  const stringifiedParams = stringifyProperties(params);
  const queryString = stringifiedParams.length ? `?${stringifiedParams}` : '';
  return `${url}${queryString}`;
};

export default attachParamsToUrl;
